// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Q = require("./Q.bs.js");
var Z = require("./Z.bs.js");
var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var CCOpt = require("./containers/CCOpt.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var CCList = require("./containers/CCList.bs.js");
var Format = require("bs-platform/lib/js/format.js");
var $$String = require("bs-platform/lib/js/string.js");
var CCFormat = require("./containers/CCFormat.bs.js");
var CCString = require("./containers/CCString.bs.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Caml_string = require("bs-platform/lib/js/caml_string.js");
var BigInteger = require("big-integer");
var BigRational = require("big-rational");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

function $eq$eq(param, param$1) {
  throw [
        Caml_builtin_exceptions.assert_failure,
        /* tuple */[
          "prelude.iml",
          11,
          18
        ]
      ];
}

function $bang$eq(param, param$1) {
  throw [
        Caml_builtin_exceptions.assert_failure,
        /* tuple */[
          "prelude.iml",
          12,
          18
        ]
      ];
}

var prefix = CCString.prefix;

var suffix = CCString.suffix;

function contains(a, sub) {
  return CCString.mem(undefined, sub, a);
}

function unsafe_to_nat(s) {
  try {
    var n = BigInteger(s);
    if (n.lt(BigInteger.zero)) {
      return BigInteger.minusOne;
    } else {
      return n;
    }
  }
  catch (exn){
    return BigInteger.minusOne;
  }
}

var $$String$1 = {
  make: $$String.make,
  init: $$String.init,
  copy: $$String.copy,
  sub: $$String.sub,
  fill: $$String.fill,
  blit: $$String.blit,
  concat: $$String.concat,
  iter: $$String.iter,
  iteri: $$String.iteri,
  map: $$String.map,
  mapi: $$String.mapi,
  trim: $$String.trim,
  escaped: $$String.escaped,
  index: $$String.index,
  index_opt: $$String.index_opt,
  rindex: $$String.rindex,
  rindex_opt: $$String.rindex_opt,
  index_from: $$String.index_from,
  index_from_opt: $$String.index_from_opt,
  rindex_from: $$String.rindex_from,
  rindex_from_opt: $$String.rindex_from_opt,
  contains_from: $$String.contains_from,
  rcontains_from: $$String.rcontains_from,
  uppercase: $$String.uppercase,
  lowercase: $$String.lowercase,
  capitalize: $$String.capitalize,
  uncapitalize: $$String.uncapitalize,
  uppercase_ascii: $$String.uppercase_ascii,
  lowercase_ascii: $$String.lowercase_ascii,
  capitalize_ascii: $$String.capitalize_ascii,
  uncapitalize_ascii: $$String.uncapitalize_ascii,
  compare: $$String.compare,
  equal: $$String.equal,
  split_on_char: $$String.split_on_char,
  prefix: prefix,
  suffix: suffix,
  contains: contains,
  unsafe_to_nat: unsafe_to_nat
};

var float_of_string = Caml_format.caml_float_of_string;

function count_function_actual_implem(param) {
  return Pervasives.failwith("the `count` function is not evaluable, its only purpose is helping proving termination of function in Logic mode");
}

function of_int(i) {
  return i;
}

function Int_$plus(prim, prim$1) {
  return prim + prim$1 | 0;
}

function Int_$(prim, prim$1) {
  return prim - prim$1 | 0;
}

function Int_$tilde$(prim) {
  return -prim | 0;
}

var Int_$star = Caml_int32.imul;

var Int_$slash = Caml_int32.div;

var Int_mod = Caml_int32.mod_;

function Int_$less(prim, prim$1) {
  return prim < prim$1;
}

function Int_$less$eq(prim, prim$1) {
  return prim <= prim$1;
}

function Int_$great(prim, prim$1) {
  return prim > prim$1;
}

function Int_$great$eq(prim, prim$1) {
  return prim >= prim$1;
}

function Int_min(prim, prim$1) {
  if (prim < prim$1) {
    return prim;
  } else {
    return prim$1;
  }
}

function Int_max(prim, prim$1) {
  if (prim > prim$1) {
    return prim;
  } else {
    return prim$1;
  }
}

function Int_incr(prim) {
  prim.contents = prim.contents + 1 | 0;
  return /* () */0;
}

function Int_decr(prim) {
  prim.contents = prim.contents - 1 | 0;
  return /* () */0;
}

function Int_succ(prim) {
  return prim + 1 | 0;
}

function Int_pred(prim) {
  return prim - 1 | 0;
}

var Int = {
  $plus: Int_$plus,
  $neg: Int_$,
  $tilde$neg: Int_$tilde$,
  $star: Int_$star,
  $slash: Int_$slash,
  mod: Int_mod,
  $less: Int_$less,
  $less$eq: Int_$less$eq,
  $great: Int_$great,
  $great$eq: Int_$great$eq,
  min: Int_min,
  max: Int_max,
  incr: Int_incr,
  decr: Int_decr,
  succ: Int_succ,
  pred: Int_pred,
  of_int: of_int
};

var Caml = {
  invalid_arg: Pervasives.invalid_arg,
  failwith: Pervasives.failwith,
  Exit: Pervasives.Exit,
  abs: Pervasives.abs,
  max_int: Pervasives.max_int,
  min_int: Pervasives.min_int,
  lnot: Pervasives.lnot,
  infinity: Pervasives.infinity,
  neg_infinity: Pervasives.neg_infinity,
  max_float: Pervasives.max_float,
  min_float: Pervasives.min_float,
  epsilon_float: Pervasives.epsilon_float,
  classify_float: Pervasives.classify_float,
  char_of_int: Pervasives.char_of_int,
  string_of_bool: Pervasives.string_of_bool,
  bool_of_string: Pervasives.bool_of_string,
  bool_of_string_opt: Pervasives.bool_of_string_opt,
  int_of_string_opt: Pervasives.int_of_string_opt,
  string_of_float: Pervasives.string_of_float,
  float_of_string_opt: Pervasives.float_of_string_opt,
  $at: Pervasives.$at,
  stdin: Pervasives.stdin,
  stdout: Pervasives.stdout,
  stderr: Pervasives.stderr,
  print_char: Pervasives.print_char,
  print_string: Pervasives.print_string,
  print_bytes: Pervasives.print_bytes,
  print_int: Pervasives.print_int,
  print_float: Pervasives.print_float,
  print_newline: Pervasives.print_newline,
  prerr_char: Pervasives.prerr_char,
  prerr_string: Pervasives.prerr_string,
  prerr_bytes: Pervasives.prerr_bytes,
  prerr_int: Pervasives.prerr_int,
  prerr_float: Pervasives.prerr_float,
  prerr_newline: Pervasives.prerr_newline,
  read_line: Pervasives.read_line,
  read_int: Pervasives.read_int,
  read_int_opt: Pervasives.read_int_opt,
  read_float: Pervasives.read_float,
  read_float_opt: Pervasives.read_float_opt,
  open_out: Pervasives.open_out,
  open_out_bin: Pervasives.open_out_bin,
  open_out_gen: Pervasives.open_out_gen,
  flush: Pervasives.flush,
  flush_all: Pervasives.flush_all,
  output_char: Pervasives.output_char,
  output_string: Pervasives.output_string,
  output_bytes: Pervasives.output_bytes,
  output: Pervasives.output,
  output_substring: Pervasives.output_substring,
  output_byte: Pervasives.output_byte,
  output_binary_int: Pervasives.output_binary_int,
  output_value: Pervasives.output_value,
  seek_out: Pervasives.seek_out,
  pos_out: Pervasives.pos_out,
  out_channel_length: Pervasives.out_channel_length,
  close_out: Pervasives.close_out,
  close_out_noerr: Pervasives.close_out_noerr,
  set_binary_mode_out: Pervasives.set_binary_mode_out,
  open_in: Pervasives.open_in,
  open_in_bin: Pervasives.open_in_bin,
  open_in_gen: Pervasives.open_in_gen,
  input_char: Pervasives.input_char,
  input_line: Pervasives.input_line,
  input: Pervasives.input,
  really_input: Pervasives.really_input,
  really_input_string: Pervasives.really_input_string,
  input_byte: Pervasives.input_byte,
  input_binary_int: Pervasives.input_binary_int,
  input_value: Pervasives.input_value,
  seek_in: Pervasives.seek_in,
  pos_in: Pervasives.pos_in,
  in_channel_length: Pervasives.in_channel_length,
  close_in: Pervasives.close_in,
  close_in_noerr: Pervasives.close_in_noerr,
  set_binary_mode_in: Pervasives.set_binary_mode_in,
  LargeFile: Pervasives.LargeFile,
  string_of_format: Pervasives.string_of_format,
  $caret$caret: Pervasives.$caret$caret,
  exit: Pervasives.exit,
  at_exit: Pervasives.at_exit,
  valid_float_lexem: Pervasives.valid_float_lexem,
  unsafe_really_input: Pervasives.unsafe_really_input,
  do_at_exit: Pervasives.do_at_exit,
  $eq$eq: $eq$eq,
  $bang$eq: $bang$eq,
  $$String: $$String$1,
  Char: /* alias */0,
  List: /* alias */0,
  $$Array: /* alias */0,
  $$Set: /* alias */0,
  $$Map: /* alias */0,
  Printf: /* alias */0,
  Format: /* alias */0,
  float_of_string: float_of_string,
  count_function_actual_implem: count_function_actual_implem,
  Int: Int
};

var Unix = { };

var Sys = { };

var $eq = Caml_obj.caml_equal;

function $less(prim, prim$1) {
  return prim.lt(prim$1);
}

function $less$eq(prim, prim$1) {
  return prim.leq(prim$1);
}

function $great(prim, prim$1) {
  return prim.gt(prim$1);
}

function $great$eq(prim, prim$1) {
  return prim.geq(prim$1);
}

function min(prim, prim$1) {
  return BigInteger.min(prim, prim$1);
}

function max(prim, prim$1) {
  return BigInteger.max(prim, prim$1);
}

function $less$dot(prim, prim$1) {
  return prim.lt(prim$1);
}

function $less$eq$dot(prim, prim$1) {
  return prim.leq(prim$1);
}

function $great$dot(prim, prim$1) {
  return prim.gt(prim$1);
}

function $great$eq$dot(prim, prim$1) {
  return prim.geq(prim$1);
}

var $less$great = Caml_obj.caml_notequal;

function not(prim) {
  return !prim;
}

function implies(x, y) {
  if (x) {
    return y;
  } else {
    return true;
  }
}

function explies(x, y) {
  if (y) {
    return x;
  } else {
    return true;
  }
}

function iff(x, y) {
  if (x ? y : true) {
    if (y) {
      return x;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

function $plus(prim, prim$1) {
  return prim.add(prim$1);
}

function $tilde$neg(prim) {
  return prim.negate();
}

function abs(x) {
  if (x.geq(BigInteger(0))) {
    return x;
  } else {
    return x.negate();
  }
}

function mk_nat(x) {
  if (x.geq(BigInteger(0))) {
    return x;
  } else {
    return BigInteger(0);
  }
}

function $neg(prim, prim$1) {
  return prim.subtract(prim$1);
}

function $tilde$plus(x) {
  return x;
}

function $star(prim, prim$1) {
  return prim.multiply(prim$1);
}

function $$const(x, param) {
  return x;
}

function compare(x, y) {
  if (Caml_obj.caml_equal(x, y)) {
    return BigInteger(0);
  } else if (x.lt(y)) {
    return BigInteger(-1);
  } else {
    return BigInteger(1);
  }
}

function pp(out, x) {
  var pp_coeff = function (out, x) {
    if (BigInteger.one.equals(x)) {
      return /* () */0;
    } else {
      return Curry._2(Format.fprintf(out, /* Format */[
                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                              /* Magic_size */Block.__(1, [
                                  "@<1>",
                                  1
                                ]),
                              /* String_literal */Block.__(11, [
                                  "\xc2\xb7",
                                  /* End_of_format */0
                                ])
                            ])]),
                      "%a@<1>\xc2\xb7"
                    ]), Z.pp_print, x);
    }
  };
  var pp$1 = function (out, param) {
    if (param.tag) {
      return Curry._6(Format.fprintf(out, /* Format */[
                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                              /* Magic_size */Block.__(1, [
                                  "@<1>",
                                  1
                                ]),
                              /* String_literal */Block.__(11, [
                                  "\xcf\x89",
                                  /* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* End_of_format */0])])
                                ])
                            ])]),
                      "%a@<1>\xcf\x89%a%a"
                    ]), pp_coeff, param[1], pp_power, param[0], pp_tail, param[2]);
    } else {
      return Z.pp_print(out, param[0]);
    }
  };
  var pp_tail = function (out, x) {
    if (!x.tag && BigInteger.zero.equals(x[0])) {
      return /* () */0;
    }
    return Curry._2(Format.fprintf(out, /* Format */[
                    /* Formatting_lit */Block.__(17, [
                        /* Break */Block.__(0, [
                            "@ ",
                            1,
                            0
                          ]),
                        /* String_literal */Block.__(11, [
                            "+ ",
                            /* Alpha */Block.__(15, [/* End_of_format */0])
                          ])
                      ]),
                    "@ + %a"
                  ]), pp$1, x);
  };
  var pp_power = function (out, x) {
    if (!x.tag && BigInteger.one.equals(x[0])) {
      return /* () */0;
    }
    return Curry._2(Format.fprintf(out, /* Format */[
                    /* Char_literal */Block.__(12, [
                        /* "^" */94,
                        /* Alpha */Block.__(15, [/* End_of_format */0])
                      ]),
                    "^%a"
                  ]), pp_inner, x);
  };
  var pp_inner = function (out, x) {
    if (x.tag) {
      return Curry._2(Format.fprintf(out, /* Format */[
                      /* Char_literal */Block.__(12, [
                          /* "(" */40,
                          /* Formatting_gen */Block.__(18, [
                              /* Open_box */Block.__(1, [/* Format */[
                                    /* End_of_format */0,
                                    ""
                                  ]]),
                              /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                      /* Close_box */0,
                                      /* Char_literal */Block.__(12, [
                                          /* ")" */41,
                                          /* End_of_format */0
                                        ])
                                    ])])
                            ])
                        ]),
                      "(@[%a@])"
                    ]), pp$1, x);
    } else {
      return pp$1(out, x);
    }
  };
  return Curry._2(Format.fprintf(out, /* Format */[
                  /* Formatting_gen */Block.__(18, [
                      /* Open_box */Block.__(1, [/* Format */[
                            /* End_of_format */0,
                            ""
                          ]]),
                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                              /* Close_box */0,
                              /* End_of_format */0
                            ])])
                    ]),
                  "@[%a@]"
                ]), pp$1, x);
}

var zero = /* Int */Block.__(0, [BigInteger(0)]);

var one = /* Int */Block.__(0, [BigInteger(1)]);

var two = /* Int */Block.__(0, [BigInteger(2)]);

function of_int$1(x) {
  return /* Int */Block.__(0, [mk_nat(x)]);
}

function $less$less(_x, _y) {
  while(true) {
    var y = _y;
    var x = _x;
    if (x.tag) {
      var x1 = x[1];
      var a1 = x[0];
      if (y.tag) {
        var x2 = y[1];
        var a2 = y[0];
        if ($less$less(a1, a2)) {
          return true;
        } else if (Caml_obj.caml_equal(a1, a2)) {
          if (x1.lt(x2)) {
            return true;
          } else if (Caml_obj.caml_equal(x1, x2)) {
            _y = y[2];
            _x = x[2];
            continue ;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else if (y.tag) {
      return true;
    } else {
      return x[0].lt(y[0]);
    }
  };
}

function plus(x, y) {
  if (x.tag) {
    var tl = x[2];
    var x$1 = x[1];
    var a = x[0];
    if (y.tag) {
      var a2 = y[0];
      if ($less$less(a, a2)) {
        return y;
      } else if (Caml_obj.caml_equal(a, a2)) {
        return /* Cons */Block.__(1, [
                  a,
                  x$1.add(y[1]),
                  y[2]
                ]);
      } else {
        return /* Cons */Block.__(1, [
                  a,
                  x$1,
                  plus(tl, y)
                ]);
      }
    } else {
      return /* Cons */Block.__(1, [
                a,
                x$1,
                plus(tl, y)
              ]);
    }
  } else if (y.tag) {
    return y;
  } else {
    return /* Int */Block.__(0, [x[0].add(y[0])]);
  }
}

function shift(x, n) {
  if (Caml_obj.caml_equal(n, /* Int */Block.__(0, [BigInteger(0)])) || Caml_obj.caml_equal(x, /* Int */Block.__(0, [BigInteger(0)]))) {
    return x;
  } else if (x.tag) {
    return /* Cons */Block.__(1, [
              plus(x[0], n),
              x[1],
              shift(x[2], n)
            ]);
  } else {
    return /* Cons */Block.__(1, [
              n,
              x[0],
              zero
            ]);
  }
}

function pair(x, y) {
  if (x.tag) {
    return /* Cons */Block.__(1, [
              plus(x[0], one),
              x[1],
              y
            ]);
  } else {
    return /* Cons */Block.__(1, [
              one,
              x[0].add(BigInteger(1)),
              y
            ]);
  }
}

function simple_plus(x, y) {
  if (x.tag) {
    return /* Int */Block.__(0, [BigInteger(0)]);
  } else if (y.tag) {
    return /* Int */Block.__(0, [BigInteger(0)]);
  } else {
    return /* Int */Block.__(0, [x[0].add(y[0])]);
  }
}

function of_list(l) {
  if (l) {
    var match = l[1];
    var x = l[0];
    if (match) {
      var match$1 = match[1];
      var y = match[0];
      if (match$1) {
        var tl = match$1[1];
        var z = match$1[0];
        if (tl) {
          var _acc = plus(shift(x, two), plus(shift(y, one), z));
          var _l = tl;
          while(true) {
            var l$1 = _l;
            var acc = _acc;
            if (l$1) {
              _l = l$1[1];
              _acc = plus(shift(acc, one), l$1[0]);
              continue ;
            } else {
              return acc;
            }
          };
        } else {
          return plus(shift(x, two), plus(shift(y, one), z));
        }
      } else {
        return plus(shift(x, one), y);
      }
    } else {
      return x;
    }
  } else {
    return zero;
  }
}

function is_valid_rec(x) {
  if (x.tag) {
    var tl = x[2];
    var a = x[0];
    if (is_valid_rec(a) && Caml_obj.caml_notequal(a, zero) && x[1].gt(BigInteger(0)) && is_valid_rec(tl)) {
      if (tl.tag) {
        return $less$less(tl[0], a);
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    return x[0].geq(BigInteger(0));
  }
}

function is_valid(x) {
  if (x.tag) {
    return is_valid_rec(x);
  } else {
    return x[0].geq(BigInteger(0));
  }
}

var omega = of_list(/* :: */[
      one,
      /* :: */[
        zero,
        /* [] */0
      ]
    ]);

var omega_omega = shift(omega, omega);

var Ordinal = {
  pp: pp,
  of_int: of_int$1,
  $tilde$: of_int$1,
  $less$less: $less$less,
  plus: plus,
  simple_plus: simple_plus,
  $plus: plus,
  of_list: of_list,
  pair: pair,
  shift: shift,
  is_valid: is_valid,
  zero: zero,
  one: one,
  omega: omega,
  omega_omega: omega_omega
};

function succ(x) {
  return /* S */[x];
}

function of_int$2(i) {
  if (i.leq(BigInteger(0))) {
    return /* Z */0;
  } else {
    return /* S */[of_int$2(i.subtract(BigInteger(1)))];
  }
}

function to_int(x) {
  if (x) {
    return BigInteger(1).add(to_int(x[0]));
  } else {
    return BigInteger(0);
  }
}

function plus$1(x, y) {
  if (x) {
    return /* S */[plus$1(x[0], y)];
  } else {
    return y;
  }
}

function leq(_x, _y) {
  while(true) {
    var y = _y;
    var x = _x;
    if (x) {
      if (y) {
        _y = y[0];
        _x = x[0];
        continue ;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
}

var Peano_nat = {
  zero: /* Z */0,
  succ: succ,
  of_int: of_int$2,
  to_int: to_int,
  plus: plus$1,
  leq: leq,
  $eq: $eq,
  $less$eq: leq,
  $plus: plus$1
};

function $$return(x) {
  return /* Ok */Block.__(0, [x]);
}

function fail(s) {
  return /* Error */Block.__(1, [s]);
}

function map(f, e) {
  if (e.tag) {
    return /* Error */Block.__(1, [e[0]]);
  } else {
    return /* Ok */Block.__(0, [Curry._1(f, e[0])]);
  }
}

function map_err(f, e) {
  if (e.tag) {
    return /* Error */Block.__(1, [Curry._1(f, e[0])]);
  } else {
    return e;
  }
}

function get_or(e, $$default) {
  if (e.tag) {
    return $$default;
  } else {
    return e[0];
  }
}

function map_or(f, e, $$default) {
  if (e.tag) {
    return $$default;
  } else {
    return Curry._1(f, e[0]);
  }
}

function $great$pipe$eq(e, f) {
  return map(f, e);
}

function flat_map(f, e) {
  if (e.tag) {
    return /* Error */Block.__(1, [e[0]]);
  } else {
    return Curry._1(f, e[0]);
  }
}

function $great$great$eq(e, f) {
  return flat_map(f, e);
}

function fold(ok, error, x) {
  if (x.tag) {
    return Curry._1(error, x[0]);
  } else {
    return Curry._1(ok, x[0]);
  }
}

function is_ok(param) {
  if (param.tag) {
    return false;
  } else {
    return true;
  }
}

function is_error(param) {
  if (param.tag) {
    return true;
  } else {
    return false;
  }
}

var Result = {
  $$return: $$return,
  fail: fail,
  map: map,
  map_err: map_err,
  get_or: get_or,
  map_or: map_or,
  $great$pipe$eq: $great$pipe$eq,
  flat_map: flat_map,
  $great$great$eq: $great$great$eq,
  fold: fold,
  is_ok: is_ok,
  is_error: is_error
};

function $pipe$great(x, f) {
  return Curry._1(f, x);
}

function $at$at(f, x) {
  return Curry._1(f, x);
}

function id(x) {
  return x;
}

function $percent$great(f, g, x) {
  return Curry._1(g, Curry._1(f, x));
}

function $plus$dot(prim, prim$1) {
  return prim.add(prim$1);
}

function $neg$dot(prim, prim$1) {
  return prim.subtract(prim$1);
}

function $tilde$neg$dot(prim) {
  return prim.neg();
}

function $star$dot(prim, prim$1) {
  return prim.multiply(prim$1);
}

function $slash$dot(prim, prim$1) {
  return prim.divide(prim$1);
}

function $eq$eq$great(a, b) {
  if (a) {
    return b;
  } else {
    return true;
  }
}

function $less$eq$eq(a, b) {
  if (b) {
    return a;
  } else {
    return true;
  }
}

var $less$eq$eq$great = iff;

function is_empty(param) {
  if (param) {
    return false;
  } else {
    return true;
  }
}

function cons(x, y) {
  return /* :: */[
          x,
          y
        ];
}

function $$return$1(x) {
  return /* :: */[
          x,
          /* [] */0
        ];
}

function append(l1, l2) {
  if (l1) {
    return /* :: */[
            l1[0],
            append(l1[1], l2)
          ];
  } else {
    return l2;
  }
}

function append_to_nil(x) {
  return Caml_obj.caml_equal(append(x, /* [] */0), x);
}

function append_single(x, y, z) {
  return Caml_obj.caml_equal(append(append(y, /* :: */[
                      x,
                      /* [] */0
                    ]), z), append(y, /* :: */[
                  x,
                  z
                ]));
}

function rev(l) {
  if (l) {
    return append(rev(l[1]), /* :: */[
                l[0],
                /* [] */0
              ]);
  } else {
    return /* [] */0;
  }
}

function length(l) {
  if (l) {
    return BigInteger(1).add(length(l[1]));
  } else {
    return BigInteger(0);
  }
}

function len_nonnegative(l) {
  return length(l).geq(BigInteger(0));
}

function len_zero_is_empty(x) {
  return Caml_obj.caml_equal(Caml_obj.caml_equal(length(x), BigInteger(0)), Caml_obj.caml_equal(x, /* [] */0));
}

function split(l) {
  if (l) {
    var match = l[0];
    var match$1 = split(l[1]);
    return /* tuple */[
            /* :: */[
              match[0],
              match$1[0]
            ],
            /* :: */[
              match[1],
              match$1[1]
            ]
          ];
  } else {
    return /* tuple */[
            /* [] */0,
            /* [] */0
          ];
  }
}

function map$1(f, l) {
  if (l) {
    return /* :: */[
            Curry._1(f, l[0]),
            map$1(f, l[1])
          ];
  } else {
    return /* [] */0;
  }
}

function map2(f, l1, l2) {
  if (l1) {
    if (l2) {
      var partial_arg = Curry._2(f, l1[0], l2[0]);
      return map((function (param) {
                    return /* :: */[
                            partial_arg,
                            param
                          ];
                  }), map2(f, l1[1], l2[1]));
    } else {
      return /* Error */Block.__(1, ["Lengths of l1 and l2 don't match"]);
    }
  } else if (l2) {
    return /* Error */Block.__(1, ["Lengths of l1 and l2 don't match"]);
  } else {
    return /* Ok */Block.__(0, [/* [] */0]);
  }
}

function for_all(f, _l) {
  while(true) {
    var l = _l;
    if (l) {
      if (Curry._1(f, l[0])) {
        _l = l[1];
        continue ;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
}

function exists(f, _l) {
  while(true) {
    var l = _l;
    if (l) {
      if (Curry._1(f, l[0])) {
        return true;
      } else {
        _l = l[1];
        continue ;
      }
    } else {
      return false;
    }
  };
}

function fold_left(f, _acc, _param) {
  while(true) {
    var param = _param;
    var acc = _acc;
    if (param) {
      _param = param[1];
      _acc = Curry._2(f, acc, param[0]);
      continue ;
    } else {
      return acc;
    }
  };
}

function fold_right(f, base, l) {
  if (l) {
    return Curry._2(f, l[0], fold_right(f, base, l[1]));
  } else {
    return base;
  }
}

function mapi($staropt$star, f, l) {
  var base = $staropt$star !== undefined ? Caml_option.valFromOption($staropt$star) : BigInteger(0);
  if (l) {
    return /* :: */[
            Curry._2(f, base, l[0]),
            mapi(Caml_option.some(base.add(BigInteger(1))), f, l[1])
          ];
  } else {
    return /* [] */0;
  }
}

function filter(f, param) {
  if (param) {
    var x = param[0];
    var tail = filter(f, param[1]);
    if (Curry._1(f, x)) {
      return /* :: */[
              x,
              tail
            ];
    } else {
      return tail;
    }
  } else {
    return /* [] */0;
  }
}

function filter_map(f, param) {
  if (param) {
    var tail = filter_map(f, param[1]);
    var match = Curry._1(f, param[0]);
    if (match !== undefined) {
      return /* :: */[
              Caml_option.valFromOption(match),
              tail
            ];
    } else {
      return tail;
    }
  } else {
    return /* [] */0;
  }
}

function flat_map$1(f, param) {
  if (param) {
    return append(Curry._1(f, param[0]), flat_map$1(f, param[1]));
  } else {
    return /* [] */0;
  }
}

function find(f, _l) {
  while(true) {
    var l = _l;
    if (l) {
      var x = l[0];
      if (Curry._1(f, x)) {
        return Caml_option.some(x);
      } else {
        _l = l[1];
        continue ;
      }
    } else {
      return ;
    }
  };
}

function mem(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      if (Caml_obj.caml_equal(x, param[0])) {
        return true;
      } else {
        _param = param[1];
        continue ;
      }
    } else {
      return false;
    }
  };
}

function mem_assoc(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      if (Caml_obj.caml_equal(x, param[0][0])) {
        return true;
      } else {
        _param = param[1];
        continue ;
      }
    } else {
      return false;
    }
  };
}

function nth(_n, _param) {
  while(true) {
    var param = _param;
    var n = _n;
    if (param) {
      if (Caml_obj.caml_equal(n, BigInteger(0))) {
        return Caml_option.some(param[0]);
      } else {
        _param = param[1];
        _n = n.subtract(BigInteger(1));
        continue ;
      }
    } else {
      return ;
    }
  };
}

function assoc(x, _param) {
  while(true) {
    var param = _param;
    if (param) {
      var match = param[0];
      if (Caml_obj.caml_equal(x, match[0])) {
        return Caml_option.some(match[1]);
      } else {
        _param = param[1];
        continue ;
      }
    } else {
      return ;
    }
  };
}

function take(n, param) {
  if (param && !n.leq(BigInteger(0))) {
    return /* :: */[
            param[0],
            take(n.subtract(BigInteger(1)), param[1])
          ];
  } else {
    return /* [] */0;
  }
}

function drop(_n, _l) {
  while(true) {
    var l = _l;
    var n = _n;
    if (l) {
      if (n.leq(BigInteger(0))) {
        return l;
      } else {
        _l = l[1];
        _n = n.subtract(BigInteger(1));
        continue ;
      }
    } else {
      return /* [] */0;
    }
  };
}

function $neg$neg(i, j) {
  if (i.geq(j)) {
    return /* [] */0;
  } else {
    return /* :: */[
            i,
            $neg$neg(i.add(BigInteger(1)), j)
          ];
  }
}

function insert_sorted(leq, x, l) {
  if (l) {
    var y = l[0];
    if (Curry._2(leq, x, y)) {
      return /* :: */[
              x,
              l
            ];
    } else {
      return /* :: */[
              y,
              insert_sorted(leq, x, l[1])
            ];
    }
  } else {
    return /* :: */[
            x,
            /* [] */0
          ];
  }
}

function sort(leq, l) {
  return fold_left((function (acc, x) {
                return insert_sorted(leq, x, acc);
              }), /* [] */0, l);
}

function is_sorted(leq, _param) {
  while(true) {
    var param = _param;
    if (param) {
      var tail = param[1];
      if (tail) {
        if (Curry._2(leq, param[0], tail[0])) {
          _param = tail;
          continue ;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  };
}

var List$1 = {
  empty: /* [] */0,
  is_empty: is_empty,
  cons: cons,
  $$return: $$return$1,
  hd: List.hd,
  tl: List.tl,
  append: append,
  append_to_nil: append_to_nil,
  append_single: append_single,
  rev: rev,
  length: length,
  len_nonnegative: len_nonnegative,
  len_zero_is_empty: len_zero_is_empty,
  split: split,
  map: map$1,
  map2: map2,
  for_all: for_all,
  exists: exists,
  fold_left: fold_left,
  fold_right: fold_right,
  mapi: mapi,
  filter: filter,
  filter_map: filter_map,
  flat_map: flat_map$1,
  find: find,
  mem: mem,
  mem_assoc: mem_assoc,
  nth: nth,
  assoc: assoc,
  take: take,
  drop: drop,
  $neg$neg: $neg$neg,
  insert_sorted: insert_sorted,
  sort: sort,
  is_sorted: is_sorted
};

function to_string(prim) {
  return prim.toString();
}

var compare$1 = Caml_obj.caml_compare;

function of_caml_int(prim) {
  return BigInteger(prim);
}

function for_(_i, j, f) {
  while(true) {
    var i = _i;
    if (i.leq(j)) {
      Curry._1(f, i);
      _i = i.add(BigInteger(1));
      continue ;
    } else {
      return 0;
    }
  };
}

function for_down_to(_i, j, f) {
  while(true) {
    var i = _i;
    if (i.geq(j)) {
      Curry._1(f, i);
      _i = i.subtract(BigInteger(1));
      continue ;
    } else {
      return 0;
    }
  };
}

var Int$1 = {
  $plus: $plus,
  $neg: $neg,
  $tilde$neg: $tilde$neg,
  $star: $star,
  $slash: Z.ediv,
  mod: Z.erem,
  $less: $less,
  $less$eq: $less$eq,
  $great: $great,
  $great$eq: $great$eq,
  min: min,
  max: max,
  abs: abs,
  to_string: to_string,
  equal: $eq,
  compare: compare$1,
  pp: Z.pp_print,
  of_caml_int: of_caml_int,
  for_: for_,
  for_down_to: for_down_to
};

var Bool = { };

function get(a, i) {
  return Caml_array.caml_array_get(a, i.valueOf());
}

function set(a, i, v) {
  return Caml_array.caml_array_set(a, i.valueOf(), v);
}

function make(i, x) {
  return Caml_array.caml_make_vect(i.valueOf(), x);
}

function init(i, f) {
  return $$Array.init(i.valueOf(), (function (i) {
                return Curry._1(f, BigInteger(i));
              }));
}

function sub(a, i, len) {
  return $$Array.sub(a, i.valueOf(), len.valueOf());
}

function length$1(a) {
  return BigInteger(a.length);
}

function mapi$1(f, a) {
  return $$Array.mapi((function (i, x) {
                return Curry._2(f, BigInteger(i), x);
              }), a);
}

function iteri(f, a) {
  return $$Array.iteri((function (i, x) {
                return Curry._2(f, BigInteger(i), x);
              }), a);
}

function fill(a, i, len, x) {
  return $$Array.fill(a, i.valueOf(), len.valueOf(), x);
}

function blit(a, i, b, j, len) {
  return $$Array.blit(a, i.valueOf(), b, j.valueOf(), len.valueOf());
}

var $$Array$1 = {
  make_float: $$Array.make_float,
  make_matrix: $$Array.make_matrix,
  create_matrix: $$Array.create_matrix,
  append: $$Array.append,
  concat: $$Array.concat,
  copy: $$Array.copy,
  to_list: $$Array.to_list,
  of_list: $$Array.of_list,
  iter: $$Array.iter,
  map: $$Array.map,
  fold_left: $$Array.fold_left,
  fold_right: $$Array.fold_right,
  iter2: $$Array.iter2,
  map2: $$Array.map2,
  for_all: $$Array.for_all,
  exists: $$Array.exists,
  mem: $$Array.mem,
  memq: $$Array.memq,
  sort: $$Array.sort,
  stable_sort: $$Array.stable_sort,
  fast_sort: $$Array.fast_sort,
  Floatarray: $$Array.Floatarray,
  get: get,
  set: set,
  make: make,
  init: init,
  sub: sub,
  length: length$1,
  mapi: mapi$1,
  iteri: iteri,
  fill: fill,
  blit: blit
};

function map$2(f, param) {
  if (param !== undefined) {
    return Caml_option.some(Curry._1(f, Caml_option.valFromOption(param)));
  }
  
}

function map_or$1($$default, f, param) {
  if (param !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(param));
  } else {
    return $$default;
  }
}

function is_some(param) {
  return param !== undefined;
}

function is_none(param) {
  return param === undefined;
}

function $$return$2(x) {
  return Caml_option.some(x);
}

function $great$pipe$eq$1(x, f) {
  return map$2(f, x);
}

function flat_map$2(f, o) {
  if (o !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(o));
  }
  
}

function $great$great$eq$1(o, f) {
  return flat_map$2(f, o);
}

function or_(else_, a) {
  if (a !== undefined) {
    return a;
  } else {
    return else_;
  }
}

function $less$plus$great(a, b) {
  return or_(b, a);
}

function exists$1(p, param) {
  if (param !== undefined) {
    return Curry._1(p, Caml_option.valFromOption(param));
  } else {
    return false;
  }
}

function for_all$1(p, param) {
  if (param !== undefined) {
    return Curry._1(p, Caml_option.valFromOption(param));
  } else {
    return true;
  }
}

function get_or$1($$default, x) {
  if (x !== undefined) {
    return Caml_option.valFromOption(x);
  } else {
    return $$default;
  }
}

function fold$1(f, acc, o) {
  if (o !== undefined) {
    return Curry._2(f, acc, Caml_option.valFromOption(o));
  } else {
    return acc;
  }
}

var $$Option = {
  map: map$2,
  map_or: map_or$1,
  is_some: is_some,
  is_none: is_none,
  $$return: $$return$2,
  $great$pipe$eq: $great$pipe$eq$1,
  flat_map: flat_map$2,
  $great$great$eq: $great$great$eq$1,
  or_: or_,
  $less$plus$great: $less$plus$great,
  exists: exists$1,
  for_all: for_all$1,
  get_or: get_or$1,
  fold: fold$1,
  $less$$great: map$2
};

function of_int$3(prim) {
  return BigRational(prim);
}

function abs$1(r) {
  if (r.geq(BigRational(BigInteger(0)))) {
    return r;
  } else {
    return r.neg();
  }
}

function mk_of_float(prim) {
  return BigRational(prim);
}

function mk_of_q(x) {
  return x;
}

function mk_of_string(x) {
  return BigRational(x);
}

function to_float(prim) {
  return prim.valueOf();
}

function of_float(prim) {
  return BigRational(prim);
}

function compare$2(x, y) {
  if (Caml_obj.caml_equal(x, y)) {
    return 0;
  } else if (x.lt(y)) {
    return -1;
  } else {
    return 1;
  }
}

function to_string$1(prim) {
  return prim.toString();
}

function to_string_approx(x) {
  return Pervasives.string_of_float(x.valueOf());
}

var Real = {
  of_int: of_int$3,
  $plus: $plus$dot,
  $neg: $neg$dot,
  $tilde$neg: $tilde$neg$dot,
  $star: $star$dot,
  $slash: $slash$dot,
  $less: $less$dot,
  $less$eq: $less$eq$dot,
  $great: $great$dot,
  $great$eq: $great$eq$dot,
  abs: abs$1,
  min: Q.min,
  max: Q.max,
  mk_of_float: mk_of_float,
  mk_of_q: mk_of_q,
  mk_of_string: mk_of_string,
  to_float: to_float,
  of_float: of_float,
  compare: compare$2,
  pp: Q.pp_print,
  to_string: to_string$1,
  to_string_approx: to_string_approx
};

function $$const$1(x) {
  return {
          l: /* [] */0,
          default: x
        };
}

function add_rec(k, v, m) {
  var aux = function (l) {
    if (l) {
      var tail = l[1];
      var match = l[0];
      var k$prime = match[0];
      var n = Caml_obj.caml_compare(k, k$prime);
      if (n !== 0) {
        if (Curry._2(Int_$less, n, 0)) {
          if (Caml_obj.caml_equal(v, m.default)) {
            return l;
          } else {
            return /* :: */[
                    /* tuple */[
                      k,
                      v
                    ],
                    l
                  ];
          }
        } else {
          return /* :: */[
                  /* tuple */[
                    k$prime,
                    match[1]
                  ],
                  aux(tail)
                ];
        }
      } else if (Caml_obj.caml_equal(v, m.default)) {
        return tail;
      } else {
        return /* :: */[
                /* tuple */[
                  k,
                  v
                ],
                tail
              ];
      }
    } else if (Caml_obj.caml_equal(v, m.default)) {
      return /* [] */0;
    } else {
      return /* :: */[
              /* tuple */[
                k,
                v
              ],
              /* [] */0
            ];
    }
  };
  return {
          l: aux(m.l),
          default: m.default
        };
}

function add$prime(m, k, v) {
  return add_rec(k, v, m);
}

var add = add_rec;

function get_default(m) {
  return m.default;
}

function get_rec(k, m) {
  var _l = m.l;
  while(true) {
    var l = _l;
    if (l) {
      var match = l[0];
      if (Caml_obj.caml_equal(k, match[0])) {
        return match[1];
      } else {
        _l = l[1];
        continue ;
      }
    } else {
      return m.default;
    }
  };
}

function get$prime(m, k) {
  return get_rec(k, m);
}

var get$1 = get_rec;

function of_list$1($$default, l) {
  if (l) {
    var match = l[0];
    return add_rec(match[0], match[1], of_list$1($$default, l[1]));
  } else {
    return {
            l: /* [] */0,
            default: $$default
          };
  }
}

function filter_map$1($$default, f, m) {
  var aux = function (param) {
    if (param) {
      var match = param[0];
      var x = match[0];
      var tl = aux(param[1]);
      var match$1 = Curry._2(f, x, match[1]);
      if (match$1 !== undefined) {
        return /* :: */[
                /* tuple */[
                  x,
                  Caml_option.valFromOption(match$1)
                ],
                tl
              ];
      } else {
        return tl;
      }
    } else {
      return /* [] */0;
    }
  };
  return {
          l: aux(m.l),
          default: Curry._1($$default, m.default)
        };
}

function for_all$2($$default, f, m) {
  if (Curry._1($$default, m.default)) {
    return for_all((function (param) {
                  return Curry._2(f, param[0], param[1]);
                }), m.l);
  } else {
    return false;
  }
}

function merge($$default, f_both, f1, f2, s1, s2) {
  var aux = function (l1, l2) {
    if (l1) {
      if (l2) {
        var tl2 = l2[1];
        var match = l2[0];
        var v2 = match[1];
        var x2 = match[0];
        var tl1 = l1[1];
        var match$1 = l1[0];
        var v1 = match$1[1];
        var x1 = match$1[0];
        if (Caml_obj.caml_equal(x1, x2)) {
          var tl = aux(tl1, tl2);
          var match$2 = Curry._3(f_both, x1, v1, v2);
          if (match$2 !== undefined) {
            return /* :: */[
                    /* tuple */[
                      x1,
                      Caml_option.valFromOption(match$2)
                    ],
                    tl
                  ];
          } else {
            return tl;
          }
        } else if (Caml_obj.caml_lessthan(x1, x2)) {
          var tl$1 = aux(tl1, l2);
          var match$3 = Curry._2(f1, x1, v1);
          if (match$3 !== undefined) {
            return /* :: */[
                    /* tuple */[
                      x1,
                      Caml_option.valFromOption(match$3)
                    ],
                    tl$1
                  ];
          } else {
            return tl$1;
          }
        } else {
          var tl$2 = aux(l1, tl2);
          var match$4 = Curry._2(f2, x2, v2);
          if (match$4 !== undefined) {
            return /* :: */[
                    /* tuple */[
                      x2,
                      Caml_option.valFromOption(match$4)
                    ],
                    tl$2
                  ];
          } else {
            return tl$2;
          }
        }
      } else {
        return CCList.filter_map((function (param) {
                      var k = param[0];
                      return CCOpt.map((function (v) {
                                    return /* tuple */[
                                            k,
                                            v
                                          ];
                                  }), Curry._2(f1, k, param[1]));
                    }), l1);
      }
    } else if (l2) {
      return CCList.filter_map((function (param) {
                    var k = param[0];
                    return CCOpt.map((function (v) {
                                  return /* tuple */[
                                          k,
                                          v
                                        ];
                                }), Curry._2(f2, k, param[1]));
                  }), l2);
    } else {
      return /* [] */0;
    }
  };
  return {
          l: aux(s1.l, s2.l),
          default: Curry._2($$default, s1.default, s2.default)
        };
}

function extract(m) {
  return /* tuple */[
          m.l,
          m.default
        ];
}

function pp$1(pp_k, pp_v, out, m) {
  var match = m.l;
  if (match) {
    var pp_sep = function (out, param) {
      return Format.fprintf(out, /* Format */[
                  /* Char_literal */Block.__(12, [
                      /* ";" */59,
                      /* Formatting_lit */Block.__(17, [
                          /* Break */Block.__(0, [
                              "@ ",
                              1,
                              0
                            ]),
                          /* End_of_format */0
                        ])
                    ]),
                  ";@ "
                ]);
    };
    var pp_pair = function (out, param) {
      return Curry._4(Format.fprintf(out, /* Format */[
                      /* Char_literal */Block.__(12, [
                          /* "(" */40,
                          /* Formatting_gen */Block.__(18, [
                              /* Open_box */Block.__(1, [/* Format */[
                                    /* End_of_format */0,
                                    ""
                                  ]]),
                              /* Alpha */Block.__(15, [/* Char_literal */Block.__(12, [
                                      /* "," */44,
                                      /* Formatting_lit */Block.__(17, [
                                          /* Break */Block.__(0, [
                                              "@ ",
                                              1,
                                              0
                                            ]),
                                          /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                  /* Close_box */0,
                                                  /* Char_literal */Block.__(12, [
                                                      /* ")" */41,
                                                      /* End_of_format */0
                                                    ])
                                                ])])
                                        ])
                                    ])])
                            ])
                        ]),
                      "(@[%a,@ %a@])"
                    ]), pp_k, param[0], pp_v, param[1]);
    };
    var partial_arg = pp_sep;
    return Curry._4(Format.fprintf(out, /* Format */[
                    /* Char_literal */Block.__(12, [
                        /* "(" */40,
                        /* Formatting_gen */Block.__(18, [
                            /* Open_box */Block.__(1, [/* Format */[
                                  /* End_of_format */0,
                                  ""
                                ]]),
                            /* String_literal */Block.__(11, [
                                "Map.of_list",
                                /* Formatting_lit */Block.__(17, [
                                    /* Break */Block.__(0, [
                                        "@ ",
                                        1,
                                        0
                                      ]),
                                    /* String_literal */Block.__(11, [
                                        "~default:",
                                        /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                /* Break */Block.__(0, [
                                                    "@ ",
                                                    1,
                                                    0
                                                  ]),
                                                /* Char_literal */Block.__(12, [
                                                    /* "[" */91,
                                                    /* Formatting_gen */Block.__(18, [
                                                        /* Open_box */Block.__(1, [/* Format */[
                                                              /* End_of_format */0,
                                                              ""
                                                            ]]),
                                                        /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                                /* Close_box */0,
                                                                /* Char_literal */Block.__(12, [
                                                                    /* "]" */93,
                                                                    /* Formatting_lit */Block.__(17, [
                                                                        /* Close_box */0,
                                                                        /* Char_literal */Block.__(12, [
                                                                            /* ")" */41,
                                                                            /* End_of_format */0
                                                                          ])
                                                                      ])
                                                                  ])
                                                              ])])
                                                      ])
                                                  ])
                                              ])])
                                      ])
                                  ])
                              ])
                          ])
                      ]),
                    "(@[Map.of_list@ ~default:%a@ [@[%a@]]@])"
                  ]), pp_v, m.default, (function (param, param$1) {
                  return Format.pp_print_list(partial_arg, pp_pair, param, param$1);
                }), m.l);
  } else {
    return Curry._2(Format.fprintf(out, /* Format */[
                    /* Char_literal */Block.__(12, [
                        /* "(" */40,
                        /* Formatting_gen */Block.__(18, [
                            /* Open_box */Block.__(1, [/* Format */[
                                  /* End_of_format */0,
                                  ""
                                ]]),
                            /* String_literal */Block.__(11, [
                                "Map.const ",
                                /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                        /* Close_box */0,
                                        /* Char_literal */Block.__(12, [
                                            /* ")" */41,
                                            /* End_of_format */0
                                          ])
                                      ])])
                              ])
                          ])
                      ]),
                    "(@[Map.const %a@])"
                  ]), pp_v, m.default);
  }
}

var $$Map = {
  $$const: $$const$1,
  add: add,
  add$prime: add$prime,
  get: get$1,
  get$prime: get$prime,
  get_default: get_default,
  of_list: of_list$1,
  filter_map: filter_map$1,
  for_all: for_all$2,
  merge: merge,
  extract: extract,
  pp: pp$1
};

var empty_default = BigInteger(0);

var empty = {
  l: /* [] */0,
  default: empty_default
};

function add$1(x, m) {
  return add_rec(x, get_rec(x, m).add(BigInteger(1)), m);
}

function mem$1(x, m) {
  return get_rec(x, m).gt(BigInteger(0));
}

function remove(x, m) {
  var n = BigInteger.max(BigInteger(0), get_rec(x, m).subtract(BigInteger(1)));
  return add_rec(x, n, m);
}

function of_list$2(param) {
  if (param) {
    return add$1(param[0], of_list$2(param[1]));
  } else {
    return empty;
  }
}

var Multiset = {
  empty: empty,
  add: add$1,
  remove: remove,
  mem: mem$1,
  find: get$1,
  of_list: of_list$2
};

var empty$1 = {
  l: /* [] */0,
  default: false
};

function is_empty$1(s) {
  return Caml_obj.caml_equal(s, empty$1);
}

function is_valid$1(s) {
  return !s.default;
}

var mem$2 = get_rec;

function subset(s1, s2) {
  return for_all$2((function (v1) {
                if (v1) {
                  return s2.default;
                } else {
                  return true;
                }
              }), (function (x, v1) {
                if (v1) {
                  return get_rec(x, s2);
                } else {
                  return true;
                }
              }), s1);
}

function add$2(x, s) {
  return add_rec(x, true, s);
}

function remove$1(x, s) {
  return add_rec(x, false, s);
}

function inter_(s1, s2) {
  return merge((function (v1, v2) {
                if (v1) {
                  throw [
                        Caml_builtin_exceptions.assert_failure,
                        /* tuple */[
                          "prelude.iml",
                          1149,
                          21
                        ]
                      ];
                }
                if (v2) {
                  throw [
                        Caml_builtin_exceptions.assert_failure,
                        /* tuple */[
                          "prelude.iml",
                          1149,
                          38
                        ]
                      ];
                }
                return false;
              }), (function (param, s1, s2) {
                if (s1 && s2) {
                  return true;
                }
                
              }), (function (param, param$1) {
                return ;
              }), (function (param, param$1) {
                return ;
              }), s1, s2);
}

function union_(s1, s2) {
  return merge((function (v1, v2) {
                if (v1) {
                  throw [
                        Caml_builtin_exceptions.assert_failure,
                        /* tuple */[
                          "prelude.iml",
                          1158,
                          21
                        ]
                      ];
                }
                if (v2) {
                  throw [
                        Caml_builtin_exceptions.assert_failure,
                        /* tuple */[
                          "prelude.iml",
                          1158,
                          38
                        ]
                      ];
                }
                return false;
              }), (function (param, s1, s2) {
                if (s1 || s2) {
                  return true;
                }
                
              }), (function (param, param$1) {
                return true;
              }), (function (param, param$1) {
                return true;
              }), s1, s2);
}

function diff_(s1, s2) {
  return merge((function (v1, v2) {
                if (v1) {
                  throw [
                        Caml_builtin_exceptions.assert_failure,
                        /* tuple */[
                          "prelude.iml",
                          1167,
                          21
                        ]
                      ];
                }
                if (v2) {
                  throw [
                        Caml_builtin_exceptions.assert_failure,
                        /* tuple */[
                          "prelude.iml",
                          1167,
                          38
                        ]
                      ];
                }
                return false;
              }), (function (param, s1, s2) {
                if (s1 && !s2) {
                  return true;
                }
                
              }), (function (param, param$1) {
                return true;
              }), (function (param, param$1) {
                return ;
              }), s1, s2);
}

function of_list$3(param) {
  if (param) {
    var s = of_list$3(param[1]);
    return add_rec(param[0], true, s);
  } else {
    return empty$1;
  }
}

function to_list(s) {
  var match = extract(s);
  return CCList.filter_map((function (param) {
                if (param[1]) {
                  return Caml_option.some(param[0]);
                }
                
              }), match[0]);
}

function pp$2(pp_x, out, x) {
  var l = to_list(x);
  if (l) {
    var partial_arg = (function (out, param) {
        return Format.fprintf(out, /* Format */[
                    /* Char_literal */Block.__(12, [
                        /* ";" */59,
                        /* Formatting_lit */Block.__(17, [
                            /* Break */Block.__(0, [
                                "@ ",
                                1,
                                0
                              ]),
                            /* End_of_format */0
                          ])
                      ]),
                    ";@ "
                  ]);
      });
    return Curry._2(Format.fprintf(out, /* Format */[
                    /* Char_literal */Block.__(12, [
                        /* "(" */40,
                        /* Formatting_gen */Block.__(18, [
                            /* Open_box */Block.__(1, [/* Format */[
                                  /* End_of_format */0,
                                  ""
                                ]]),
                            /* String_literal */Block.__(11, [
                                "Set.of_list",
                                /* Formatting_lit */Block.__(17, [
                                    /* Break */Block.__(0, [
                                        "@ ",
                                        1,
                                        0
                                      ]),
                                    /* Char_literal */Block.__(12, [
                                        /* "[" */91,
                                        /* Formatting_gen */Block.__(18, [
                                            /* Open_box */Block.__(1, [/* Format */[
                                                  /* End_of_format */0,
                                                  ""
                                                ]]),
                                            /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                    /* Close_box */0,
                                                    /* Char_literal */Block.__(12, [
                                                        /* "]" */93,
                                                        /* Formatting_lit */Block.__(17, [
                                                            /* Close_box */0,
                                                            /* Char_literal */Block.__(12, [
                                                                /* ")" */41,
                                                                /* End_of_format */0
                                                              ])
                                                          ])
                                                      ])
                                                  ])])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ]),
                    "(@[Set.of_list@ [@[%a@]]@])"
                  ]), (function (param, param$1) {
                  return Format.pp_print_list(partial_arg, pp_x, param, param$1);
                }), l);
  } else {
    return Format.pp_print_string(out, "Set.empty");
  }
}

var $$Set = {
  empty: empty$1,
  is_valid: is_valid$1,
  is_empty: is_empty$1,
  mem: mem$2,
  add: add$2,
  remove: remove$1,
  subset: subset,
  union: union_,
  inter: inter_,
  diff: diff_,
  $plus$plus: union_,
  $neg$neg: diff_,
  of_list: of_list$3,
  to_list: to_list,
  pp: pp$2
};

function length$2(s) {
  return BigInteger(s.length);
}

var make$1 = $$String.make;

function append$1(prim, prim$1) {
  return prim + prim$1;
}

var get$2 = Caml_string.get;

function concat(sep, l) {
  if (l) {
    var tail = l[1];
    var x = l[0];
    if (tail) {
      return x + (sep + concat(sep, tail));
    } else {
      return x;
    }
  } else {
    return "";
  }
}

var prefix$1 = CCString.prefix;

var suffix$1 = CCString.suffix;

function contains$1(a, sub) {
  return CCString.mem(undefined, sub, a);
}

function unsafe_sub(a, i, len) {
  return $$String.sub(a, i.valueOf(), len.valueOf());
}

function sub$1(a, i, len) {
  if (i.geq(BigInteger(0)) && len.geq(BigInteger(0)) && i.add(len).leq(BigInteger(a.length))) {
    return unsafe_sub(a, i, len);
  }
  
}

function of_int$4(i) {
  if (i.geq(BigInteger(0))) {
    return i.toString();
  } else {
    return "-" + i.negate().toString();
  }
}

function to_nat(s) {
  var x = unsafe_to_nat(s);
  if (x.geq(BigInteger(0))) {
    return Caml_option.some(x);
  }
  
}

var $$String$2 = {
  empty: "",
  length: length$2,
  make: make$1,
  append: append$1,
  get: get$2,
  concat: concat,
  prefix: prefix$1,
  suffix: suffix$1,
  contains: contains$1,
  unsafe_sub: unsafe_sub,
  sub: sub$1,
  of_int: of_int$4,
  to_nat: to_nat,
  unsafe_to_nat: unsafe_to_nat
};

function succ$1(x) {
  return x.add(BigInteger(1));
}

function pred(x) {
  return x.subtract(BigInteger(1));
}

function fst(param) {
  return param[0];
}

function snd(param) {
  return param[1];
}

var Round = { };

function of_int$5(prim) {
  return prim.valueOf();
}

function $tilde$neg$1(prim) {
  return -prim;
}

function $plus$1(prim, prim$1) {
  return prim + prim$1;
}

function $neg$1(prim, prim$1) {
  return prim - prim$1;
}

function $star$1(prim, prim$1) {
  return prim * prim$1;
}

function $slash(prim, prim$1) {
  return prim / prim$1;
}

var nan = Number.NaN;

function $less$1(prim, prim$1) {
  return prim < prim$1;
}

function $less$eq$1(prim, prim$1) {
  return prim <= prim$1;
}

function $great$1(prim, prim$1) {
  return prim > prim$1;
}

function $great$eq$1(prim, prim$1) {
  return prim >= prim$1;
}

function $eq$1(prim, prim$1) {
  return prim === prim$1;
}

function $less$great$1(prim, prim$1) {
  return prim !== prim$1;
}

function abs$2(prim) {
  return Math.abs(prim);
}

function is_zero(x) {
  return x === Caml_format.caml_float_of_string("0.");
}

function is_nan(x) {
  return Pervasives.classify_float(x) === /* FP_nan */4;
}

function is_infinite(x) {
  return Pervasives.classify_float(x) === /* FP_infinite */3;
}

function is_normal(x) {
  return Pervasives.classify_float(x) === /* FP_normal */0;
}

function is_subnormal(x) {
  return Pervasives.classify_float(x) === /* FP_subnormal */1;
}

function is_positive(x) {
  return x > Caml_format.caml_float_of_string("0.");
}

function is_negative(x) {
  return x < Caml_format.caml_float_of_string("0.");
}

function min$1(x, y) {
  if (Pervasives.classify_float(x) === /* FP_nan */4 || !(Pervasives.classify_float(y) === /* FP_nan */4 || x < y)) {
    return y;
  } else {
    return x;
  }
}

function max$1(x, y) {
  if (Pervasives.classify_float(x) === /* FP_nan */4 || !(Pervasives.classify_float(y) === /* FP_nan */4 || x > y)) {
    return y;
  } else {
    return x;
  }
}

function rem(prim, prim$1) {
  return prim % prim$1;
}

function sqrt(prim) {
  return Math.sqrt(prim);
}

var Float = {
  Round: Round,
  of_int: of_int$5,
  of_string: float_of_string,
  $tilde$neg: $tilde$neg$1,
  $plus: $plus$1,
  $neg: $neg$1,
  $star: $star$1,
  $slash: $slash,
  nan: nan,
  infinity: Pervasives.infinity,
  $less: $less$1,
  $less$eq: $less$eq$1,
  $great: $great$1,
  $great$eq: $great$eq$1,
  $eq: $eq$1,
  $less$great: $less$great$1,
  neg: $tilde$neg$1,
  abs: abs$2,
  is_zero: is_zero,
  is_nan: is_nan,
  is_infinite: is_infinite,
  is_normal: is_normal,
  is_subnormal: is_subnormal,
  is_positive: is_positive,
  is_negative: is_negative,
  min: min$1,
  max: max$1,
  rem: rem,
  sqrt: sqrt
};

function pp$3(out, x) {
  return CCFormat.string(out, x.name);
}

var Uid = {
  pp: pp$3
};

function pp$4(out, x) {
  switch (x.tag | 0) {
    case /* Var */0 :
        return CCFormat.string(out, x[0]);
    case /* Arrow */1 :
        var s = x[0];
        if (s === "") {
          return Curry._4(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                          /* Break */Block.__(0, [
                                              "@ ",
                                              1,
                                              0
                                            ]),
                                          /* String_literal */Block.__(11, [
                                              "-> ",
                                              /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                      /* Close_box */0,
                                                      /* Char_literal */Block.__(12, [
                                                          /* ")" */41,
                                                          /* End_of_format */0
                                                        ])
                                                    ])])
                                            ])
                                        ])])
                                ])
                            ]),
                          "(@[%a@ -> %a@])"
                        ]), pp$4, x[1], pp$4, x[2]);
        } else {
          return Curry._5(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* String */Block.__(2, [
                                      /* No_padding */0,
                                      /* Char_literal */Block.__(12, [
                                          /* ":" */58,
                                          /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                  /* Break */Block.__(0, [
                                                      "@ ",
                                                      1,
                                                      0
                                                    ]),
                                                  /* String_literal */Block.__(11, [
                                                      "-> ",
                                                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                              /* Close_box */0,
                                                              /* Char_literal */Block.__(12, [
                                                                  /* ")" */41,
                                                                  /* End_of_format */0
                                                                ])
                                                            ])])
                                                    ])
                                                ])])
                                        ])
                                    ])
                                ])
                            ]),
                          "(@[%s:%a@ -> %a@])"
                        ]), s, pp$4, x[1], pp$4, x[2]);
        }
    case /* Tuple */2 :
        var partial_arg = /* Format */[
          /* Char_literal */Block.__(12, [
              /* "," */44,
              /* Formatting_lit */Block.__(17, [
                  /* Break */Block.__(0, [
                      "@ ",
                      1,
                      0
                    ]),
                  /* End_of_format */0
                ])
            ]),
          ",@ "
        ];
        var partial_arg$1 = (function (param, param$1) {
            return CCFormat.$$return(partial_arg, param, param$1);
          });
        return Curry._2(CCFormat.fprintf(out, /* Format */[
                        /* Char_literal */Block.__(12, [
                            /* "(" */40,
                            /* Formatting_gen */Block.__(18, [
                                /* Open_box */Block.__(1, [/* Format */[
                                      /* End_of_format */0,
                                      ""
                                    ]]),
                                /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                        /* Close_box */0,
                                        /* Char_literal */Block.__(12, [
                                            /* ")" */41,
                                            /* End_of_format */0
                                          ])
                                      ])])
                              ])
                          ]),
                        "(@[%a@])"
                      ]), (function (param, param$1) {
                      return CCFormat.list(partial_arg$1, pp$4, param, param$1);
                    }), x[0]);
    case /* Constr */3 :
        var l = x[1];
        var id = x[0];
        if (l) {
          if (l[1]) {
            var partial_arg$2 = /* Format */[
              /* Char_literal */Block.__(12, [
                  /* "," */44,
                  /* Formatting_lit */Block.__(17, [
                      /* Break */Block.__(0, [
                          "@ ",
                          1,
                          0
                        ]),
                      /* End_of_format */0
                    ])
                ]),
              ",@ "
            ];
            var partial_arg$3 = (function (param, param$1) {
                return CCFormat.$$return(partial_arg$2, param, param$1);
              });
            return Curry._4(CCFormat.fprintf(out, /* Format */[
                            /* Char_literal */Block.__(12, [
                                /* "(" */40,
                                /* Formatting_gen */Block.__(18, [
                                    /* Open_box */Block.__(1, [/* Format */[
                                          /* End_of_format */0,
                                          ""
                                        ]]),
                                    /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                            /* Close_box */0,
                                            /* String_literal */Block.__(11, [
                                                ") ",
                                                /* Alpha */Block.__(15, [/* End_of_format */0])
                                              ])
                                          ])])
                                  ])
                              ]),
                            "(@[%a@]) %a"
                          ]), (function (param, param$1) {
                          return CCFormat.list(partial_arg$3, pp$4, param, param$1);
                        }), l, pp$3, id);
          } else {
            return Curry._4(CCFormat.fprintf(out, /* Format */[
                            /* Formatting_gen */Block.__(18, [
                                /* Open_box */Block.__(1, [/* Format */[
                                      /* End_of_format */0,
                                      ""
                                    ]]),
                                /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                        /* Break */Block.__(0, [
                                            "@ ",
                                            1,
                                            0
                                          ]),
                                        /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                /* Close_box */0,
                                                /* End_of_format */0
                                              ])])
                                      ])])
                              ]),
                            "@[%a@ %a@]"
                          ]), pp$4, l[0], pp$3, id);
          }
        } else {
          return CCFormat.string(out, id.name);
        }
    
  }
}

var Type = {
  pp: pp$4
};

function pp_name(out, x) {
  return CCFormat.string(out, x.id.name);
}

function pp$5(out, x) {
  return Curry._4(CCFormat.fprintf(out, /* Format */[
                  /* Char_literal */Block.__(12, [
                      /* "(" */40,
                      /* Formatting_gen */Block.__(18, [
                          /* Open_box */Block.__(1, [/* Format */[
                                /* End_of_format */0,
                                ""
                              ]]),
                          /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                  /* Break */Block.__(0, [
                                      "@ ",
                                      1,
                                      0
                                    ]),
                                  /* String_literal */Block.__(11, [
                                      ": ",
                                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                              /* Close_box */0,
                                              /* Char_literal */Block.__(12, [
                                                  /* ")" */41,
                                                  /* End_of_format */0
                                                ])
                                            ])])
                                    ])
                                ])])
                        ])
                    ]),
                  "(@[%a@ : %a@])"
                ]), pp$3, x.id, pp$4, x.ty);
}

var Var = {
  pp_name: pp_name,
  pp: pp$5
};

function pp_const(out, param) {
  switch (param.tag | 0) {
    case /* Const_string */0 :
        return Curry._1(CCFormat.fprintf(out, /* Format */[
                        /* Caml_string */Block.__(3, [
                            /* No_padding */0,
                            /* End_of_format */0
                          ]),
                        "%S"
                      ]), param[0]);
    case /* Const_z */1 :
        return Z.pp_print(out, param[0]);
    case /* Const_q */2 :
        return Q.pp_print(out, param[0]);
    
  }
}

function pp$6(out, _param) {
  while(true) {
    var param = _param;
    switch (param.tag | 0) {
      case /* Bool */0 :
          return CCFormat.bool(out, param[0]);
      case /* Const */1 :
          return pp_const(out, param[0]);
      case /* If */2 :
          return Curry._6(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* String_literal */Block.__(11, [
                                      "if ",
                                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                              /* Break */Block.__(0, [
                                                  "@ ",
                                                  1,
                                                  0
                                                ]),
                                              /* String_literal */Block.__(11, [
                                                  "then ",
                                                  /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                          /* Break */Block.__(0, [
                                                              "@ ",
                                                              1,
                                                              0
                                                            ]),
                                                          /* String_literal */Block.__(11, [
                                                              "else ",
                                                              /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                                      /* Close_box */0,
                                                                      /* Char_literal */Block.__(12, [
                                                                          /* ")" */41,
                                                                          /* End_of_format */0
                                                                        ])
                                                                    ])])
                                                            ])
                                                        ])])
                                                ])
                                            ])])
                                    ])
                                ])
                            ]),
                          "(@[if %a@ then %a@ else %a@])"
                        ]), pp$6, param[0], pp$6, param[1], pp$6, param[2]);
      case /* Apply */3 :
          var l = param[1];
          var f = param[0];
          if (l) {
            var partial_arg = /* Format */[
              /* Formatting_lit */Block.__(17, [
                  /* Break */Block.__(0, [
                      "@ ",
                      1,
                      0
                    ]),
                  /* End_of_format */0
                ]),
              "@ "
            ];
            var partial_arg$1 = (function(partial_arg){
            return function (param, param$1) {
              return CCFormat.$$return(partial_arg, param, param$1);
            }
            }(partial_arg));
            return Curry._4(CCFormat.fprintf(out, /* Format */[
                            /* Char_literal */Block.__(12, [
                                /* "(" */40,
                                /* Formatting_gen */Block.__(18, [
                                    /* Open_box */Block.__(1, [/* Format */[
                                          /* End_of_format */0,
                                          ""
                                        ]]),
                                    /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                            /* Break */Block.__(0, [
                                                "@ ",
                                                1,
                                                0
                                              ]),
                                            /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                    /* Close_box */0,
                                                    /* Char_literal */Block.__(12, [
                                                        /* ")" */41,
                                                        /* End_of_format */0
                                                      ])
                                                  ])])
                                          ])])
                                  ])
                              ]),
                            "(@[%a@ %a@])"
                          ]), pp$6, f, (function(partial_arg$1){
                      return function (param, param$1) {
                        return CCFormat.list(partial_arg$1, pp$6, param, param$1);
                      }
                      }(partial_arg$1)), l);
          } else {
            _param = f;
            continue ;
          }
      case /* Ident */4 :
          return CCFormat.string(out, param[0].name);
      case /* Tuple */5 :
          var partial_arg$2 = /* Format */[
            /* Char_literal */Block.__(12, [
                /* "," */44,
                /* Formatting_lit */Block.__(17, [
                    /* Break */Block.__(0, [
                        "@ ",
                        1,
                        0
                      ]),
                    /* End_of_format */0
                  ])
              ]),
            ",@ "
          ];
          var partial_arg$3 = (function(partial_arg$2){
          return function (param, param$1) {
            return CCFormat.$$return(partial_arg$2, param, param$1);
          }
          }(partial_arg$2));
          return Curry._2(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                          /* Close_box */0,
                                          /* Char_literal */Block.__(12, [
                                              /* ")" */41,
                                              /* End_of_format */0
                                            ])
                                        ])])
                                ])
                            ]),
                          "(@[%a@])"
                        ]), (function(partial_arg$3){
                    return function (param, param$1) {
                      return CCFormat.list(partial_arg$3, pp$6, param, param$1);
                    }
                    }(partial_arg$3)), param[0]);
      case /* Let */6 :
          var pp_binding = function (out, param) {
            return Curry._4(Format.fprintf(out, /* Format */[
                            /* Formatting_gen */Block.__(18, [
                                /* Open_box */Block.__(1, [/* Format */[
                                      /* String_literal */Block.__(11, [
                                          "<2>",
                                          /* End_of_format */0
                                        ]),
                                      "<2>"
                                    ]]),
                                /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                        /* Break */Block.__(0, [
                                            "@ ",
                                            1,
                                            0
                                          ]),
                                        /* String_literal */Block.__(11, [
                                            "= ",
                                            /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                    /* Close_box */0,
                                                    /* End_of_format */0
                                                  ])])
                                          ])
                                      ])])
                              ]),
                            "@[<2>%a@ = %a@]"
                          ]), pp_name, param[0], pp$6, param[1]);
          };
          var partial_arg$4 = /* Format */[
            /* Formatting_lit */Block.__(17, [
                /* Break */Block.__(0, [
                    "@ ",
                    1,
                    0
                  ]),
                /* String_literal */Block.__(11, [
                    "and ",
                    /* End_of_format */0
                  ])
              ]),
            "@ and "
          ];
          var partial_arg$5 = (function(partial_arg$4){
          return function (param, param$1) {
            return CCFormat.$$return(partial_arg$4, param, param$1);
          }
          }(partial_arg$4));
          return Curry._5(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* String_literal */Block.__(11, [
                                      "let",
                                      /* String */Block.__(2, [
                                          /* No_padding */0,
                                          /* Formatting_lit */Block.__(17, [
                                              /* Break */Block.__(0, [
                                                  "@ ",
                                                  1,
                                                  0
                                                ]),
                                              /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                      /* Break */Block.__(0, [
                                                          "@ ",
                                                          1,
                                                          0
                                                        ]),
                                                      /* String_literal */Block.__(11, [
                                                          "in ",
                                                          /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                                  /* Close_box */0,
                                                                  /* Char_literal */Block.__(12, [
                                                                      /* ")" */41,
                                                                      /* End_of_format */0
                                                                    ])
                                                                ])])
                                                        ])
                                                    ])])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                          "(@[let%s@ %a@ in %a@])"
                        ]), param[/* rec_ */0] ? " rec" : "", (function(partial_arg$5){
                    return function (param, param$1) {
                      return CCFormat.list(partial_arg$5, pp_binding, param, param$1);
                    }
                    }(partial_arg$5)), param[/* bindings */1], pp$6, param[/* body */2]);
      case /* Tuple_field */7 :
          return Curry._4(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* String_literal */Block.__(11, [
                                      "tuple-get-",
                                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                              /* Break */Block.__(0, [
                                                  "@ ",
                                                  1,
                                                  0
                                                ]),
                                              /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                      /* Close_box */0,
                                                      /* Char_literal */Block.__(12, [
                                                          /* ")" */41,
                                                          /* End_of_format */0
                                                        ])
                                                    ])])
                                            ])])
                                    ])
                                ])
                            ]),
                          "(@[tuple-get-%a@ %a@])"
                        ]), Z.pp_print, param[0], pp$6, param[1]);
      case /* Construct */8 :
          var l$1 = param[1];
          var id = param[0];
          if (l$1) {
            var partial_arg$6 = /* Format */[
              /* Char_literal */Block.__(12, [
                  /* "," */44,
                  /* Formatting_lit */Block.__(17, [
                      /* Break */Block.__(0, [
                          "@ ",
                          1,
                          0
                        ]),
                      /* End_of_format */0
                    ])
                ]),
              ",@ "
            ];
            var partial_arg$7 = (function(partial_arg$6){
            return function (param, param$1) {
              return CCFormat.$$return(partial_arg$6, param, param$1);
            }
            }(partial_arg$6));
            return Curry._4(Format.fprintf(out, /* Format */[
                            /* Char_literal */Block.__(12, [
                                /* "(" */40,
                                /* Formatting_gen */Block.__(18, [
                                    /* Open_box */Block.__(1, [/* Format */[
                                          /* End_of_format */0,
                                          ""
                                        ]]),
                                    /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                            /* Break */Block.__(0, [
                                                "@ ",
                                                1,
                                                0
                                              ]),
                                            /* Char_literal */Block.__(12, [
                                                /* "(" */40,
                                                /* Formatting_gen */Block.__(18, [
                                                    /* Open_box */Block.__(1, [/* Format */[
                                                          /* End_of_format */0,
                                                          ""
                                                        ]]),
                                                    /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                            /* Close_box */0,
                                                            /* Char_literal */Block.__(12, [
                                                                /* ")" */41,
                                                                /* Formatting_lit */Block.__(17, [
                                                                    /* Close_box */0,
                                                                    /* Char_literal */Block.__(12, [
                                                                        /* ")" */41,
                                                                        /* End_of_format */0
                                                                      ])
                                                                  ])
                                                              ])
                                                          ])])
                                                  ])
                                              ])
                                          ])])
                                  ])
                              ]),
                            "(@[%a@ (@[%a@])@])"
                          ]), pp$3, id, (function(partial_arg$7){
                      return function (param, param$1) {
                        return CCFormat.list(partial_arg$7, pp$6, param, param$1);
                      }
                      }(partial_arg$7)), l$1);
          } else {
            return CCFormat.string(out, id.name);
          }
      case /* Destruct */9 :
          return Curry._6(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* String_literal */Block.__(11, [
                                      "destruct-",
                                      /* Alpha */Block.__(15, [/* Char_literal */Block.__(12, [
                                              /* "-" */45,
                                              /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                      /* Break */Block.__(0, [
                                                          "@ ",
                                                          1,
                                                          0
                                                        ]),
                                                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                              /* Close_box */0,
                                                              /* Char_literal */Block.__(12, [
                                                                  /* ")" */41,
                                                                  /* End_of_format */0
                                                                ])
                                                            ])])
                                                    ])])
                                            ])])
                                    ])
                                ])
                            ]),
                          "(@[destruct-%a-%a@ %a@])"
                        ]), pp$3, param[0], Z.pp_print, param[1], pp$6, param[2]);
      case /* Is_a */10 :
          return Curry._4(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* String_literal */Block.__(11, [
                                      "is-",
                                      /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                              /* Break */Block.__(0, [
                                                  "@ ",
                                                  1,
                                                  0
                                                ]),
                                              /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                      /* Close_box */0,
                                                      /* Char_literal */Block.__(12, [
                                                          /* ")" */41,
                                                          /* End_of_format */0
                                                        ])
                                                    ])])
                                            ])])
                                    ])
                                ])
                            ]),
                          "(@[is-%a@ %a@])"
                        ]), pp$3, param[0], pp$6, param[1]);
      case /* Field */11 :
          return Curry._4(CCFormat.fprintf(out, /* Format */[
                          /* Alpha */Block.__(15, [/* Char_literal */Block.__(12, [
                                  /* "." */46,
                                  /* Alpha */Block.__(15, [/* End_of_format */0])
                                ])]),
                          "%a.%a"
                        ]), pp$6, param[1], pp$3, param[0]);
      case /* Record */12 :
          var pp_field = function (out, param) {
            return Curry._4(Format.fprintf(out, /* Format */[
                            /* Formatting_gen */Block.__(18, [
                                /* Open_box */Block.__(1, [/* Format */[
                                      /* End_of_format */0,
                                      ""
                                    ]]),
                                /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                        /* Break */Block.__(0, [
                                            "@ ",
                                            1,
                                            0
                                          ]),
                                        /* String_literal */Block.__(11, [
                                            "= ",
                                            /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                    /* Close_box */0,
                                                    /* End_of_format */0
                                                  ])])
                                          ])
                                      ])])
                              ]),
                            "@[%a@ = %a@]"
                          ]), pp$3, param[0], pp$6, param[1]);
          };
          var pp_rest = function (out, param) {
            if (param !== undefined) {
              return Curry._2(Format.fprintf(out, /* Format */[
                              /* Alpha */Block.__(15, [/* String_literal */Block.__(11, [
                                      " with",
                                      /* Formatting_lit */Block.__(17, [
                                          /* Break */Block.__(0, [
                                              "@ ",
                                              1,
                                              0
                                            ]),
                                          /* End_of_format */0
                                        ])
                                    ])]),
                              "%a with@ "
                            ]), pp$6, param);
            } else {
              return /* () */0;
            }
          };
          var partial_arg$8 = /* Format */[
            /* Char_literal */Block.__(12, [
                /* ";" */59,
                /* Formatting_lit */Block.__(17, [
                    /* Break */Block.__(0, [
                        "@ ",
                        1,
                        0
                      ]),
                    /* End_of_format */0
                  ])
              ]),
            ";@ "
          ];
          var partial_arg$9 = (function(partial_arg$8){
          return function (param, param$1) {
            return CCFormat.$$return(partial_arg$8, param, param$1);
          }
          }(partial_arg$8));
          return Curry._4(Format.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "{" */123,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* End_of_format */0,
                                        ""
                                      ]]),
                                  /* Alpha */Block.__(15, [/* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                              /* Close_box */0,
                                              /* Char_literal */Block.__(12, [
                                                  /* "}" */125,
                                                  /* End_of_format */0
                                                ])
                                            ])])])
                                ])
                            ]),
                          "{@[%a%a@]}"
                        ]), pp_rest, param[1], (function(partial_arg$9){
                    return function (param, param$1) {
                      return CCFormat.list(partial_arg$9, pp_field, param, param$1);
                    }
                    }(partial_arg$9)), param[0]);
      case /* Fun */13 :
          return Curry._4(CCFormat.fprintf(out, /* Format */[
                          /* Char_literal */Block.__(12, [
                              /* "(" */40,
                              /* Formatting_gen */Block.__(18, [
                                  /* Open_box */Block.__(1, [/* Format */[
                                        /* String_literal */Block.__(11, [
                                            "<1>",
                                            /* End_of_format */0
                                          ]),
                                        "<1>"
                                      ]]),
                                  /* String_literal */Block.__(11, [
                                      "fun ",
                                      /* Alpha */Block.__(15, [/* String_literal */Block.__(11, [
                                              " ->",
                                              /* Formatting_lit */Block.__(17, [
                                                  /* Break */Block.__(0, [
                                                      "@ ",
                                                      1,
                                                      0
                                                    ]),
                                                  /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                                          /* Close_box */0,
                                                          /* Char_literal */Block.__(12, [
                                                              /* ")" */41,
                                                              /* End_of_format */0
                                                            ])
                                                        ])])
                                                ])
                                            ])])
                                    ])
                                ])
                            ]),
                          "(@[<1>fun %a ->@ %a@])"
                        ]), pp_name, param[0], pp$6, param[1]);
      
    }
  };
}

var Term_dummy = /* Bool */Block.__(0, [true]);

var Term = {
  pp_const: pp_const,
  dummy: Term_dummy,
  pp: pp$6
};

var $$Reflect = {
  Uid: Uid,
  Type: Type,
  Var: Var,
  Term: Term
};

var Pervasives$1 = { };

var Caml_sys = /* alias */0;

var min_r = Q.min;

var max_r = Q.max;

var $slash$1 = Z.ediv;

var mod = Z.erem;

var $at = append;

var $caret = append$1;

exports.Caml = Caml;
exports.Caml_sys = Caml_sys;
exports.Unix = Unix;
exports.Sys = Sys;
exports.$eq = $eq;
exports.$less = $less;
exports.$less$eq = $less$eq;
exports.$great = $great;
exports.$great$eq = $great$eq;
exports.min = min;
exports.max = max;
exports.$less$dot = $less$dot;
exports.$less$eq$dot = $less$eq$dot;
exports.$great$dot = $great$dot;
exports.$great$eq$dot = $great$eq$dot;
exports.min_r = min_r;
exports.max_r = max_r;
exports.$less$great = $less$great;
exports.not = not;
exports.implies = implies;
exports.explies = explies;
exports.iff = iff;
exports.$plus = $plus;
exports.$tilde$neg = $tilde$neg;
exports.abs = abs;
exports.mk_nat = mk_nat;
exports.$neg = $neg;
exports.$tilde$plus = $tilde$plus;
exports.$star = $star;
exports.$slash = $slash$1;
exports.mod = mod;
exports.$$const = $$const;
exports.compare = compare;
exports.Ordinal = Ordinal;
exports.Peano_nat = Peano_nat;
exports.Result = Result;
exports.$pipe$great = $pipe$great;
exports.$at$at = $at$at;
exports.id = id;
exports.$percent$great = $percent$great;
exports.$eq$eq = $eq$eq;
exports.$bang$eq = $bang$eq;
exports.$plus$dot = $plus$dot;
exports.$neg$dot = $neg$dot;
exports.$tilde$neg$dot = $tilde$neg$dot;
exports.$star$dot = $star$dot;
exports.$slash$dot = $slash$dot;
exports.$eq$eq$great = $eq$eq$great;
exports.$less$eq$eq = $less$eq$eq;
exports.$less$eq$eq$great = $less$eq$eq$great;
exports.List = List$1;
exports.$at = $at;
exports.$neg$neg = $neg$neg;
exports.Int = Int$1;
exports.Bool = Bool;
exports.$$Array = $$Array$1;
exports.$$Option = $$Option;
exports.Real = Real;
exports.$$Map = $$Map;
exports.Multiset = Multiset;
exports.$$Set = $$Set;
exports.$$String = $$String$2;
exports.$caret = $caret;
exports.succ = succ$1;
exports.pred = pred;
exports.fst = fst;
exports.snd = snd;
exports.Float = Float;
exports.$$Reflect = $$Reflect;
exports.Pervasives = Pervasives$1;
/* zero Not a pure module */
